import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import '../../App.css'
import * as actionsCreators from  '../../store/actions/index';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import IconButton from '@material-ui/core/IconButton';
import { TimePicker } from '@material-ui/pickers'
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import DialogTitle from '@material-ui/core/DialogTitle';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import { withTranslation } from 'react-i18next';
const options = [
    {
        id: "1",
        name: "FSTP",
    }, {
        id: "2",
        name: "STP",
    }, {
        id: "3",
        name: "Pumping/Decanting station",
    }
];

class TreatmentFacilityForm extends Component {

    constructor(props) {
        super(props);
        this.handleMapClick = this.handleMapClick.bind(this);
        this.state = {
            tfName: "",
            username:  '',
            email: '',
            location: {
                latitude: "",
                longitude: ""
            },
            latitude: '',
            longitude:  '',
            capacity:  '',
            locationName:  '',
            ward:  '',
            amount: '',
            operationalHoursFrom:  moment(Date.now()).format('MM-DD-YYYY 09:00'),
            operationalHoursTo:  moment(Date.now()).format('MM-DD-YYYY 18:00'),
            receiptNumberPrefix: "",
            UserId: "",
            tfNameErr: "",
            usernameErr: "",
            emailErr: "",
            capacityErr: "",
            operationalHoursFromError: "",
            operationalHoursToError: "",
            amountErr: "",
            receiptNumberPrefixErr: "",
            longitudeErr: "",
            latitudeErr: "",
            isCheckboxOn: false,
            typeOfDisposal: '',
            facilityEmail: "",
            typeOfDisposalError: "",
            locationError: "",
            nameError: "",
            facilityIdError: "",
            locationNameErr: "",
            wardErr: "",
            feeError: "",
            position: 'inherit',
            left: '50%',
            top: '50%',
            zone:'',
            zoneErr:'',
            password:"",
            passwordErr:"",
            isPasswordShown:false,
            
        }
    }
    handleMap = (value) => {
        if (document.fullscreenElement) {
            this.setState({ position: 'fixed', top: 0, left: 0 })
        }
        else {
            this.setState({ position: 'inherit', top: '50%', left: '50%' })
        }
    }
    handleMapClick(x) {
        this.setState({ latitude: x.lat }, () => {
            this.checkValidity()
        })
        this.setState({ longitude: x.lng })
    }

    handleSubmit = (e) => {
        const {t, i18n} = this.props
        const props = this.props
        e.preventDefault()
        const err = this.checkValidity()
         if (!err) {
            const formdata = {
                UserId: this.state.UserId,
                tfName: this.state.tfName,
                amount: this.state.amount ? Number(this.state.amount) : null,
                type: parseInt(this.state.typeOfDisposal),
                capacity: this.state.capacity ? Number(this.state.capacity) : null,
                operationalHoursFrom: moment(this.state.operationalHoursFrom).format('HH:mm'),
                operationalHoursTo: moment(this.state.operationalHoursTo).format('HH:mm'),
                receiptNumberPrefix: this.state.receiptNumberPrefix ? this.state.receiptNumberPrefix : null,
                username: this.state.username,
                email: this.state.email,
                location: {
                    latitude: parseFloat(this.state.latitude),
                    longitude: parseFloat(this.state.longitude)
                },
                locationName: this.state.locationName ? this.state.locationName : null,
                wardZone: this.state.ward ? this.state.ward : null,
                zone: this.state.zone ? this.state.zone : null,
                token: this.props.token,
                props: this.props,
                password:this.state.password
            }
            // this.props.handleSubmit(formdata)
            this.props.onAddTreatmentListing(formdata,props, t)
            this.handleClose()
        }
    }
    handleChange = (e) => {
        {this.setState({
            [e.target.name]: e.target.value
        }, () => {
            this.checkValidity()
        })
        }
    }
    toggleVisibilityTip = () => {   
        const { isCheckboxOn } = this.state
        this.setState({ isCheckboxOn: !isCheckboxOn }, () => {
            this.checkValidity()
        })
    }
    checkValidity = () => {
        const {t, i18n} = this.props
        let isError = false;
        if (!this.state.tfName) {
            isError = true
            this.setState({ tfNameErr: `${t("required")}` })
        }
        else if (this.state.tfName && this.state.tfName.length < 3 || this.state.tfName.length > 100) {
            isError = true
            this.setState({ tfNameErr: `${t("ulbnameErr")}` })
        }
        else if (this.state.tfName && this.state.tfName.length >= 3 && this.state.tfName.length <= 100) {
            // isError = false
            this.setState({ tfNameErr: "" })
        }
        if (!this.state.typeOfDisposal) {
            isError = true
            this.setState({ typeOfDisposalError: `${t("required")}` })
        }
        else if (this.state.typeOfDisposal) {
            this.setState({ typeOfDisposalError: "" })
        }
        if (!this.state.username) {
            isError = true
            this.setState({ usernameErr: `${t("required")}` })
        }
        else if (this.state.username && this.state.username.length < 3 || this.state.username.length > 20) {
            isError = true
            this.setState({ usernameErr: `${t("disposalNameErr")}` })
        }
        else if (this.state.username && this.state.username.length >= 3 && this.state.username.length <= 20) {
            // isError = false
            this.setState({ usernameErr: "" })
        }
        if (!this.state.email) {
            isError = true
            this.setState({ emailErr: `${t("required")}` })
        }
        else if (this.state.email) {
            var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if (!this.state.email.match(mailformat)) {
                isError = true;
                this.setState({ emailErr: `${t("ulbEmailErr")}` })
            }
            else {
                // isError=false
                this.setState({ emailErr: "" })
            }
        }
        if (!this.state.capacity && !this.handleSubmit) {
            isError = true
            this.setState({ capacityErr: `${t("disposalCapacityErr1")}` })
        }
        else if (this.state.capacity) {
            if(!String(this.state.capacity).match(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)){
                isError = true
                this.setState({ capacityErr: `${t("disposalCapacityErr2")}` })
            }
            
            else{
                this.setState({ capacityErr: "" })
            }
        }
        if (this.state.isCheckboxOn) {
            if (!this.state.amount) {
                isError = true;
                this.setState({ amountErr: `${t("disposalAmountErr1")}` })
            }
            else if (this.state.amount) {
                if(!String(this.state.amount).match(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/)){
                    isError = true;
                    this.setState({ amountErr: `${t("disposalAmountPosErr")}` }) // changed error msg for positive
                }
                else{
                    this.setState({ amountErr: "" })
                }
            }
            if (this.state.receiptNumberPrefix) {
                this.setState({ receiptNumberPrefixErr: "" })
            }

        }
        if (!this.state.operationalHoursFrom) {
            isError = true
            this.setState({ operationalHoursFromError: `${t("required")}` })
        }
        else if (this.state.operationalHoursFrom) {
            this.setState({ operationalHoursFromError: "" })
        }
        if (!this.state.operationalHoursTo) {
            isError = true
            this.setState({ operationalHoursToError: `${t("required")}` })
        }
        else if (this.state.operationalHoursTo) {
            this.setState({ operationalHoursToError: "" })
        }
        if (this.state.operationalHoursFrom && this.state.operationalHoursTo) {
            if (moment(this.state.operationalHoursTo) <= moment(this.state.operationalHoursFrom)) {
                isError = true
                this.setState({ operationalHoursToError: "To hours cannot be lesser than/eqaul to from hours" })
            }
        }
        if (!this.state.latitude) {
            isError = true
            this.setState({ latitudeErr: `${t("required")}` })
        }
        else if (this.state.latitude) {
            this.setState({ latitudeErr: "" })
        }
        if (!this.state.longitude) {
            isError = true
            this.setState({ longitudeErr: `${t("required")}` })
        }
        else if (this.state.longitude) {
            this.setState({ longitudeErr: "" })
        }
        if (!this.state.locationName) {
            this.setState({ locationNameErr: "" })
        }
        else if (this.state.locationName) {
            if (this.state.locationName.length < 3 || this.state.locationName.length > 100) {
                isError = true
                this.setState({ locationNameErr: `${t("disposalLocalErr")}` })
            }
            else if (this.state.locationName && this.state.locationName.length >= 3 || this.state.locationName.length <= 100) {
                this.setState({ locationNameErr: "" })
            }
        }
        if (!this.state.ward) {
            this.setState({ wardErr: "" })
        }
        else if (this.state.ward) {
            if (this.state.ward.length > 100) {
                isError = true
                this.setState({ wardErr: `${t("disposalWardErr")}` })
            }
            else if (this.state.ward.length <= 100) {
                this.setState({ wardErr: "" })
            }
        }


        if(this.state.username && !this.state.password){
            isError = true
            this.setState({
                passwordErr:`${t("required")}`,
               
            })
        }
        // else{
        //     isError = false
        //     this.setState({
        //         passwordErr:''
        //     })  
        // }
       

        if(this.state.username && this.state.password){
            if(!this.state.password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
                isError = true
                this.setState({
                    passwordErr: `${t("ulbPassErr")}`
                })   
            }
            else if(isError){
                isError = true
            }
            else{
                isError = false
                this.setState({
                    passwordErr:''
                })   
            }
        }
        return isError
    }
    static defaultProps = {
        center: {
            lat: 17.123184,
            lng: 79.208824
        },
        zoom: 7,
        maps_key: "AIzaSyBV5XySVlxwJm_lAJ2ZoecKismiBv1ZJAo"
    };
    handleTimeFrom = (time) => {
        this.setState({ operationalHoursFrom: time }, () => {
            this.checkValidity()
        })
    }
    handleTimeTo = (time) => {
        this.setState({ operationalHoursTo: time }, () => {
            this.checkValidity()
        })
    }
    toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
    handleClose =()=>{
        this.props.handleClose(false)
        this.setState({tfNameErr:'',typeOfDisposalError:'',usernameErr:'',emailErr:'',
        capacityErr: "",
        operationalHoursFromError: "",
        operationalHoursToError: "",
        amountErr: "",
        receiptNumberPrefixErr: "",
        longitudeErr: "",
        latitudeErr: "",
        tfName: '',
        username:  '',
        email:  '',
        location: {
            latitude: "",
            longitude: ""
        },
        latitude:  '',
        longitude:'',
        capacity:  '',
        locationName: '',
        ward: '',
        amount:  '',
        operationalHoursFrom: moment(Date.now()).format('MM-DD-YYYY 09:00'),
        operationalHoursTo:  moment(Date.now()).format('MM-DD-YYYY 18:00'),
        zone:'',
        isCheckboxOn:  false,
        typeOfDisposal:  '',
    })
    }
    render() {
        const {t, i18n} = this.props
        return (
            <div>
                <Dialog open={this.props.open} disableBackdropClick onClose={this.handleClose} aria-labelledby="form-dialog-title" maxWidth='md'>
                <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{t("addDisposalFac")}</span></DialogTitle>
<DialogContent>
<div className="create_ulb_content_outer">
                    <div className="create_ulb_content create_ulb_contentPop">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="tfName" align="left">{t("facilityName")}</label>
                            <TextField id="tfName"
                                variant="outlined"
                                value={this.state.tfName}
                                onChange={this.handleChange}
                                name="tfName"
                                placeholder={t("phfacilityName")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.tfNameErr}</div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl>
                            <label class="required" for="typeOfDisposal" align="left">{t("faclityType")}</label>
                            <Select value={this.state.typeOfDisposal} onChange={this.handleChange} name="typeOfDisposal">
                                {options.map((option) => (
                                    // <option value={option.id}>{option.name}</option>
                                    <MenuItem value={option.id}>{option.name}</MenuItem>
                                ))}
                            </Select>
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.typeOfDisposalError}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="username" align="left">{t("facilityUser")}</label>
                            <OutlinedInput id="username"
                                variant="outlined"
                                value={this.state.username}
                                onChange={this.handleChange}
                                name="username"
                                placeholder={t("phfacilityUser")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.usernameErr}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="email" align="left">{t("facilityEmail")}</label>
                            <OutlinedInput id="email"
                                variant="outlined"
                                value={this.state.email}
                                onChange={this.handleChange}
                                name="email"
                                placeholder={t("phfacilityEmail")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.emailErr}</div>
                        </FormControl>
                    </Grid>


                    <Grid item xs={6}>
                     <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("facilityPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("phfacilityPass")}
                                      name="password" 
                                      value={this.state.password}
                                      onChange={this.handleChange}
                                      type={this.state.isPasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isPasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.toggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.toggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.passwordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                  </FormControl>
                  </form>
                    </Grid>



                    <Grid item xs={12}>
                        <div style={{ height: '30vh', width: '100%', paddingBottom: '15px', position: this.state.position, top: this.state.top, left: this.state.left }}>
                            <GoogleMapReact
                                bootstrapURLKeys={{ key: this.props.maps_key }}
                                defaultCenter={this.props.center}
                                defaultZoom={this.props.zoom}
                                onClick={this.handleMapClick}
                                onChange={this.handleMap}>
                                <Marker
                                    lat={this.state.latitude}
                                    lng={this.state.longitude}
                                    name="My Marker"
                                    color="blue" />
                            </GoogleMapReact>
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="latitude" align="left">{t("latitude")}</label>
                            <OutlinedInput id="latitude"
                                variant="outlined"
                                disabled
                                value={evaluateLocation(this.state.latitude)}
                                onChange={this.handleChange}
                                name="latitude"
                                placeholder={t("phlatitude")}
                                endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                            <div style={{ fontSize: 12, color: "red", }}>{this.state.latitudeErr}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="longitude" align="left">{t("longitude")}</label>
                            <OutlinedInput id="longitude"
                                variant="outlined"
                                disabled
                                value={evaluateLocation(this.state.longitude)}
                                onChange={this.handleChange}
                                name="longitude"
                                placeholder={t("phlongitude")}
                                endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.longitudeErr}</div>
                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="locationName" align="left">{t("location")}</label>
                            <OutlinedInput id="locationName"
                                variant="outlined"
                                value={this.state.locationName}
                                onChange={this.handleChange}
                                name="locationName"
                                placeholder={t("phlocation")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.locationNameErr}</div>

                        </FormControl>
                    </Grid>
                 

                    <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="ward" align="left">{t("ward")}</label>
                            <OutlinedInput id="ward"
                                variant="outlined"
                                type='number'
                                value={this.state.ward}
                                onChange={this.handleChange}
                                name="ward"
                                placeholder={t("ward")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.wardErr}</div>

                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="zone" align="left">{t("zone")}</label>
                            <OutlinedInput id="zone"
                                variant="outlined"
                                value={this.state.zone}
                                onChange={this.handleChange}
                                name="zone"
                                placeholder={t("zone")} />
                            <div style={{ fontSize: 12, color: "red" }}>{this.state.zoneErr}</div>

                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>

                    <FormControl>
                        <label htmlFor="capacity" align="left">{t("capacity")}</label>
                        <OutlinedInput id="capacity"
                            type="number"
                            min="0"
                            step="1"
                            variant="outlined"
                            value={this.state.capacity}
                            onChange={this.handleChange}
                            name="capacity"
                            placeholder={t("phcapacity")} />
                        <div style={{ fontSize: 12, color: "red" }}>{this.state.capacityErr}</div>
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="operationalHoursFrom" align="left">{t("operationalHoursFrom") }</label>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <TimePicker autoOk
                                    value={this.state.operationalHoursFrom}
                                    onChange={this.handleTimeFrom}
                                    InputProps={{ style: { fontSize: 'small', paddingLeft: '12px', paddingBottom: '7px', paddingTop: '7px', fontFamily: "'Open Sans', sans-serif !important}" } }} />
                                <div style={{ fontSize: 12, color: "red" }}>{this.state.operationalHoursFromError}</div>
                            </MuiPickersUtilsProvider>
                        </FormControl>

                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="operationalHoursTo" align="left">{t("operationalHoursTO")}</label>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <TimePicker autoOk
                                    value={this.state.operationalHoursTo}
                                    onChange={this.handleTimeTo}
                                    InputProps={{ style: { fontSize: 'small', paddingLeft: '12px', paddingBottom: '7px', paddingTop: '7px', fontFamily: "'Open Sans', sans-serif !important}" } }} />
                                <div style={{ fontSize: 12, color: "red" }}>{this.state.operationalHoursToError}</div>
                            </MuiPickersUtilsProvider>
                        </FormControl>
                    </Grid>
      

                    <Grid container spacing={1} item xs={6}>
                    
                        <Grid item xs={12}>
                        <FormControl>
                            <label htmlFor="amount" align="left" style={{ display: "flex", align: 'center', alignItems: "center" }}>{t("tippingFee")}
                        {!this.state.isCheckboxOn ? <CheckBoxOutlineBlankOutlinedIcon onClick={() => { this.toggleVisibilityTip() }} /> : <CheckBoxIcon style={{ color: "#3dab35" }} onClick={() => { this.toggleVisibilityTip() }} />}</label>
                        </FormControl>
                            {this.state.isCheckboxOn ?
                                <div>
                                    <FormControl style={{width:'100%', float: "left"}}>
                                        <label className="required" htmlFor="amount" align="left">{t("amount")}</label>
                                        <OutlinedInput id="amount"
                                            // type="number"
                                            variant="outlined"
                                            // min="0"
                                            // step="1" 
                                            value={this.state.amount}
                                            onChange={this.handleChange}
                                            name="amount"
                                            placeholder={t("phamount")} />
                                        <div style={{ fontSize: 12, color: "red" }}>{this.state.amountErr}</div>
                                    </FormControl>
                        &emsp;&emsp;&emsp;
                        </div> : null}
                        </Grid>
                    </Grid>
                            
                    <Grid item xs={12}>
                        <div className="create_ulb_buttons">
                         <Button className="login_submit" variant="outlined" color="primary" onClick={this.handleClose }>{t("cancel")}</Button>
                            <Button className="login_submit" variant="contained" color="primary" onClick={this.handleSubmit}>{t("save")}</Button>
                        </div>
                    </Grid>

                </Grid>
                </div>
                </div>
        </DialogContent>
    </Dialog>

            </div>
        )
    }
}

/**
 * Evaluates lat long for 4 digit precision
 * @param {*} loc - Lat Long for evaluation
 */
function evaluateLocation(loc) {
    return loc.toString().length > 0 ? parseFloat(loc).toFixed(4) : "";
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
    
    }
}


const mapDispatchToProps = dispatch => {
    return {
        onAddTreatmentListing: (formdata,props, t) => dispatch(actionsCreators.addTreatmentListing(formdata,props, t)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TreatmentFacilityForm));

